import {
  SURVEY_BUILDER_SET_LIST,
  SURVEY_BUILDER_SET_COUNT,
} from './events';

const initialState = {
  surveys: [],
  surveyCount: 0,
};

export default function surveyBuilderReducer(state = initialState, action) {
  switch (action.type) {
  case SURVEY_BUILDER_SET_LIST:
    return {
      ...state,
      surveys: action.surveys || [],
    };

  case SURVEY_BUILDER_SET_COUNT:
    return {
      ...state,
      surveyCount: action.count || 0,
    };

  default:
    return state;
  }
}
